export type Zodiac = '白羊座' | '金牛座' | '双子座' | '巨蟹座' | '狮子座' | '处女座' | '天秤座' | '天蝎座' | '射手座' | '摩羯座' | '水瓶座' | '双鱼座';

export type MBTI = 'INTJ' | 'INTP' | 'ENTJ' | 'ENTP' | 'INFJ' | 'INFP' | 'ENFJ' | 'ENFP' | 'ISTJ' | 'ISFJ' | 'ESTJ' | 'ESFJ' | 'ISTP' | 'ISFP' | 'ESTP' | 'ESFP';

/** 相亲档案：基本信息 + 自我介绍 + 家庭情况 + 择偶标准 */
export interface DatingProfile {
  height: number;          // 身高 (cm)
  education: string;       // 学历/学校
  hometown: string;        // 家乡（籍贯）
  city: string;            // 现居地
  income: string;          // 经济状况（年收入/房车等）
  hobbies: string[];       // 兴趣爱好（具体的）
  lifestyle: string;       // 生活习惯（抽烟喝酒作息等）
  family: string;          // 家庭情况（父母/兄弟姐妹/家庭氛围）
  partnerReq: string;      // 择偶硬性条件
}

export interface Character {
  id: string;
  name: string;
  age: number;
  job: string;
  bio: string;
  tags: string[];
  avatar: string; // URL
  gender: 'male' | 'female';
  idealType: string;         // 理想型（白月光/朱砂痣）
  flaws: string;             // 自身缺点
  datingResistance: string;  // 对相亲的抗拒原因
  landmines: string[];       // 雷区（踩到必炸，好感直降）
  zodiac: Zodiac;  // Visible to player in character select
  mbti: MBTI;      // Hidden — only affects AI dialogue style
  profile: DatingProfile;    // 相亲档案
}

export enum CardType {
  TOPIC = '话题',
  EVENT = '事件',
  PERSONA = '人设'
}

export type RiskLevel = 'safe' | 'normal' | 'risky';

export interface GameCard {
  id: string;
  name: string;
  type: CardType;
  description: string;
  hint: string; // Strategy hint
  cpRange: string; // e.g., "+5~+15"
  riskLevel: RiskLevel; // safe/normal/risky — independent of card type
}

export interface ChatMessage {
  id: string;
  senderId: string; // 'system' | characterId
  text: string;
  type: 'text' | 'system' | 'narrative' | 'thought';
  cpChange?: number;
}

/** Persistent buff attached to a character (from 人设卡). */
export interface ActiveBuff {
  id: string;        // Same as the source card's id
  cardName: string;  // Display name (e.g. "社恐发作")
  description: string; // Card description — used as the behavior modification prompt
}

export interface GameResult {
  title: string;
  description: string;
  score: string;
}
